import gql from "graphql-tag";

export const ADD_TO_INTERESTING = gql`
  mutation createInterestingProperty($propertyId: ID!) {
    createInterestingProperty(propertyId: $propertyId) {
      status
    }
  }
`;

export const DELETE_FROM_INTERESTING = gql`
  mutation deleteInterestingProperty($propertyId: ID!) {
    deleteInterestingProperty(propertyId: $propertyId) {
      status
    }
  }
`;

export const ADD_TO_INTERESTING_WITH_MSG = gql`
  mutation createInterestingPropertyWithMessage(
    $propertyId: ID!
    $name: String!
    $phone: String!
    $email: String
    $message: String
  ) {
    createInterestingPropertyWithMessage(
      propertyId: $propertyId
      name: $name
      phone: $phone
      email: $email
      message: $message
    ) {
      status
    }
  }
`;

export const ADD_TO_INTERESTING_WITH_MSG_NO_USER = gql`
  mutation createInterestingPropertyWithMessageNoUser(
    $propertyId: ID!
    $name: String!
    $phone: String!
    $email: String
    $message: String
  ) {
    createInterestingPropertyWithMessageNoUser(
      propertyId: $propertyId
      name: $name
      phone: $phone
      email: $email
      message: $message
    ) {
      status
    }
  }
`;

